import { useTranslation } from 'react-i18next';
import { FormDialog } from '@cbridge-tools/form';
import { useCreateNodeFormSchema, createNodeHandler, updateNodeHandler, INodeForm } from '@cbridge-packages/node';
import { IDialogProps } from '@cbridge-modules/dialog';
import { NodeForm } from '../_forms/NodeForm';
import { INodeFormDialogProps } from './NodeFormDialog.interface';

function NodeFormDialog({ payload = {}, open, onClose }: IDialogProps<INodeFormDialogProps, number | null>) {
  const { nodeId, formData } = payload;
  const { t } = useTranslation();

  const schema = useCreateNodeFormSchema();

  const handleSubmit = async (data: INodeForm) => {
    try {
      let resultNodeId: number;
      if (nodeId) {
        await updateNodeHandler(nodeId, data);
        resultNodeId = nodeId;
      } else {
        resultNodeId = await createNodeHandler(data);
      }
      await onClose(resultNodeId);
    } catch (error) {
      await onClose(null);
    }
  };

  return (
    <FormDialog<INodeForm>
      open={open}
      onClose={() => onClose(null)}
      onSubmit={handleSubmit}
      title={
        nodeId ? t('text:configPage.symbolPools.dialog.edit.title') : t('text:configPage.symbolPools.dialog.create.title')
      }
      schema={schema}
      isCreateMode={!nodeId}
      values={formData}
    >
      <NodeForm />
    </FormDialog>
  );
}

export { NodeFormDialog };
